export { default as ManagePagesLayoutSkeleton } from './manage-pages-layout-skeleton';
